var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},_vm._l((_vm.users),function(user){return _c('user-card',_vm._b({key:("" + _vm.vuexState + (user.email)),attrs:{"user":user}},'user-card',_vm.$props,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }